import { useViewjobProctorAllocation } from "../../proctor/__generated__/ViewjobProctorContext";
import { MobVjMatchOverviewResumeGateTst } from "../../proctor/__generated__/ViewjobProctorSpecifications";
import { useViewjobOneGraphModel } from "../context/ViewJobDataContext";

export interface MatchOverviewResumeGate {
  /**
   * Whether the Match Overview should be gated behind adding a resume (MJP-880).
   * True only when the seeker has no resume on file AND is in the test bucket.
   */
  isGateActive: boolean;
  /**
   * Whether the experiment is active at all, regardless of resume state. Needed
   * for the states that outlive the gate: once hydration adds a resume
   * `isGateActive` flips false, but the skeleton and unreadable-file UI still
   * belong to the gated experience and must stay behind the same flag.
   */
  isProctorActive: boolean;
}

/**
 * Resume-gate state for the Match Overview experiment (MJP-880).
 */
export function useMatchOverviewResumeGate(): MatchOverviewResumeGate {
  const hasResume = useViewjobOneGraphModel()?.jobSeeker.profile.hasResume ?? false;
  const isProctorActive = useViewjobProctorAllocation(MobVjMatchOverviewResumeGateTst).isTest;

  return { isGateActive: !hasResume && isProctorActive, isProctorActive };
}
